import React from 'react'
import { Modal, Button } from 'react-bootstrap';

const EmailModal = (props) => {

    const EmailSubmit = (event) => {
        event.preventDefault();
        props.setEmailActive(true);
        props.setCount( props.count < 2 ? props.count + 1 : props.count);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='authentication-modal'
        >
            <form onSubmit={EmailSubmit}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3 className='text-center'>EMAIL <span className="text-blue">VERIFICATION</span></h3>
                    <p className='sub-heading'>Send link to verify Email</p>
                    <div className='position-relative'>
                        <input className='form-control' type='email' placeholder='Enter Email' />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='Submit' className='btn-solid' onClick={props.onHide}>submit</Button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default EmailModal;
